//
//  localStorageHelper.js
//  <project>
//  Storage的一些业务操作
//  Created by licheng09 on 2017-11-09.
//  Copyright 2017 licheng09. All rights reserved.
//


/**
 * 是否支持无痕浏览模式
 */
const isSupportLocalStorage = () => {
    try {
        localStorage.setItem('storage', '');
        localStorage.removeItem('storage');
        return true;
    } catch (err) {
        return false;
    }
};

const lStorage = window.localStorage;
const localStorageHelper = {
    setItem(key, value) {
        if (typeof value === 'object') {
            lStorage.setItem(key, JSON.stringify(value));
        } else {
            lStorage.setItem(key, value);
        }
    },
    getItem(key) {
        if (lStorage.getItem(key) === null) {
            return null;
        } else {
            return lStorage.getItem(key);
        }
    },
    removeItem(key) {
        lStorage.removeItem(key);
    },
    clear() {
        lStorage.clear();
    },

};
const sStorage = window.sessionStorage;
const sessionStorageHelper = {
    setItem(key, value) {
        if (typeof value === 'object') {
            sStorage.setItem(key, JSON.stringify(value));
        } else {
            sStorage.setItem(key, value);
        }
    },
    getItem(key) {
        if (sStorage.getItem(key) === null) {
            return null;
        } else {
            return sStorage.getItem(key);
        }
    },
    removeItem(key) {
        sStorage.removeItem(key);
    },
    clear() {
        sStorage.clear();
    },
    getApplyStatus() {
        // 获取申请状态
        return this.getItem('applyStatus') ? JSON.parse(this.getItem('applyStatus')) : { noResult: true };
    },
    clearApplyStatus() {
        this.removeItem('applyStatus');
    },
};

export {
    isSupportLocalStorage,
    localStorageHelper,
    sessionStorageHelper,
};



// WEBPACK FOOTER //
// ./src/tools/StorageHelper.js